import { z } from 'zod';

export const venueListFilterSchema = z.object({
  countryZoneCodes: z.string().trim().nonempty().array().optional().catch(undefined)
});

export type VenueListFilterSchema = z.infer<typeof venueListFilterSchema>;
